
export const each = function(dict, func) {
    const result = {};

    Object.keys(dict).map((val, index) => {
        const res = func(val, dict[val], index);

        if (typeof result !== 'undefined') {
            result[val] = res;
        }
    });

    return result;
};

export const object2array = function(obj) {
    const result = [];

    each(obj, (key, value) => {
        result.push(value);
    });

    return result;
};

export const wrapFunction = function(props_, scope = 'data') {
    const rtn = {};
    const props = typeof props_ === 'string' ? props_.split(/[\s|,]+/g) : props_;
    props.forEach(prop => {
        rtn[prop] = {
            get: function() {
                return this[scope] ? this[scope][prop] : null;
            },
            set: function(value) {
                this[scope][prop] = value;
            },
        }
    });

    return rtn;
};

export const toDashCase = function(str_) {
    let str = str_.toLowerCase().replace(/[\s_]+/g, '-');

    each({
        'ß': 'ss',
        'ä': 'ae',
        'ö': 'oe',
        'ü': 'ue',
        // 'ä': 'a',
        // 'ö': 'o',
        // 'ü': 'u',
    }, (search, replace) => {
        str = str.replace(search, replace);
    });

    str = str.replace(/[^0-9a-z-]/g, '');

    return str;
};

export const obj = {
    get(obj, keys) {
        const keysArr = keys.split('|');

        for (let i = 0; i < keysArr.length; i++) {
            const key = keysArr[i];

            if (typeof obj[key] !== 'undefined') {
                return obj[key];
            }
        }
    }
};

export const format = function(format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function(match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
        ;
    });
};

export const createLanglog = function(lang) {
    const saved = [];
    window.langlog = function() {
        const result = {};
        saved.forEach(item => {
            result[item] = lang[item] || `en: ${item}`;
        });

        // eslint-disable-next-line no-console
        console.log(JSON.stringify(result));
    }
    return function(phrase) {
        if (saved.indexOf(phrase) === -1) {
            saved.push(phrase);
        }
    }
};
